import { lazy, Suspense } from 'react'
import { ReduxProvider } from '@/app/providers/ReduxProvider'
import { resolveUiMode } from '@/mobile/lib/uiMode'

// Both trees are lazy so each device downloads only the one it renders. The
// mobile tree in particular carries its own theme, layout and page set, and is
// dead weight in a desktop bundle.
const DesktopApp = lazy(() => import('@/app/DesktopApp'))
const MobileApp = lazy(() => import('@/mobile/MobileApp'))

// Resolved once at module load, not per render: the two trees have separate
// providers and route tables, so flipping between them mid-session would leave
// stale providers mounted. `switchUiMode` reloads the page instead.
const uiMode = resolveUiMode()

export const App = () => (
  <ReduxProvider>
    <Suspense fallback={null}>
      {uiMode === 'mobile' ? <MobileApp /> : <DesktopApp />}
    </Suspense>
  </ReduxProvider>
)
